export default __webpack_public_path__ + "static/media/events.7041fefb.svg";